"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personnelDeleteApi = personnelDeleteApi;
exports.personnelEditApi = personnelEditApi;
exports.personnelListApi = personnelListApi;
exports.personnelSaveApi = personnelSaveApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @description 商户配送人员分页列表
 */
function personnelListApi(params) {
  return (0, _request.default)({
    url: '/admin/merchant/delivery/personnel/page',
    method: 'get',
    params: params
  });
}

/**
 * @description 新增商户配送人员
 */
function personnelSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/delivery/personnel/save',
    method: 'post',
    data: data
  });
}

/**
 * @description 编辑商户配送人员
 */
function personnelEditApi(data) {
  return (0, _request.default)({
    url: '/admin/merchant/delivery/personnel/edit',
    method: 'post',
    data: data
  });
}

/**
 * @description 删除商户配送人员
 */
function personnelDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/merchant/delivery/personnel/delete/".concat(id),
    method: 'post'
  });
}